import { useAuth0 } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';
import HeroSection from './heroSection/HeroSection';
import AppFooter from '../../components/AppLayout/AppFooter/AppFooter';

export default function GetStartedPage() {
	const { loginWithRedirect } = useAuth0();
	const { t } = useTranslation();
	return (
		<>
			<section data-testid={'landing-page'}>
				<HeroSection />
			</section>
			<section>
				<AppFooter />
			</section>
		</>
	);
}
